const Work_Experience = [
  {
    designation: "Trainee – Software Engineer",
    name: "Avalon Information Systems Pvt. Ltd.",
    duration: "July 2020 - Present",
    info: [
      "Worked in a team of 2 engineers on project MANZIL.",
      "To empower adolescent girls with skills and income opportunities to delay age of marriage and first pregnancy in Rajasthan.",
      "More than 25,000 girls and 1000 employers have already been registered.",
      "Built the REST APIs for the Android Application to handle girls and employer’s registration including images.",
      "Developed an Admin Panel to view registration reports and handle the master data (like areas, training centers, etc.).",
      "To learn and prepare a team of Flutter for upcoming project revamped the Manzil app from Kotlin to Flutter.",
      "Frameworks & Tools used: Flutter, Laravel, jQuery, MySQL, SQLite, AG Grid.",
    ],
  },
  {
    designation: "Intern",
    name: "Study Abacus",
    duration: "Oct 2020 - Dec 2020",
    info: [
      "Contributed in 'online-exam-backend' project used for conducting online exams.",
      "The project was able to conduct exams of 2000+ students at a time.",
      "Developed forgot password feature: includes generating token, mailing reset link, verifying token, resetting password.",
      "Built the REST APIs for the frontend application to provide/handle the online examination related data.",
      "Frameworks & Tools used: Node.js, Fastify, PostgreSQL, Sequelize, SendGrid.",
    ],
    gitLink: "https://github.com/study-abacus/exam-online-backend",
  },
  {
    designation: "Intern",
    name: "Avalon Information Systems Pvt. Ltd.",
    duration: "Jan 2020 - Jun 2020",
    info: [
      "Worked in a team of 3 engineers on project ASMAN.",
      "It is an initiative for effectively driving the use of evidence-based best practices that reduce early maternal and newborn mortality by leveraging technology in four districts each of Madhya Pradesh and Rajasthan.",
      "Built the REST APIs for the Android Application to provide a case sheet, reports data.",
      "Implemented download feature for reports in PDF format.",
      "Frameworks & Tools used: CakePhp, jQuery, MySQL, AG Grid.",
    ],
  },
  {
    designation: "Intern",
    name: "National Informatics Centre",
    duration: "Jun 2019 - Jul 2019",
    info: [
      "Delivered a user dashboard for the Govt. project 'Parichay'.",
      "Display login details and activities of user using charts.",
      "Languages: JavaScript.",
      "Technologies & Frameworks used: React.js, HTML, CSS.",
      "Libraries used: Chart.js, Axios.",
    ],
  },
  {
    designation: "Teaching Assistant",
    name: "Coding Blocks",
    duration: "Jan 2019 - July 2019",
    info: [
      "Teaching Assistant in Launchpad (C++) Batch of Coding Blocks.",
      "Assisted batch of 60 students at a time: includes preparing assignments, quizzes.",
      "Also conducted doubt-solving sessions and debugging code using Blended learning (offline + online).",
    ],
  },
];

export { Work_Experience };
